import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostUser from 'flarum/forum/components/PostUser';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import PostStream from 'flarum/forum/components/PostStream';
import CommentPost from 'flarum/forum/components/CommentPost';
import Post from 'flarum/forum/components/Post';
import PostControls from 'flarum/forum/utils/PostControls';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Dropdown from 'flarum/common/components/Dropdown';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';
import LogInModal from 'flarum/forum/components/LogInModal';
// 注意：mentions 扩展的 reply 函数可能需要在运行时动态导入
// 先不导入，在函数内部动态获取
import RelatedTopics from './components/RelatedTopics';
import Breadcrumb from './components/Breadcrumb';
import PostStreamBreadcrumb from './components/PostStreamBreadcrumb';
import avatar from 'flarum/common/helpers/avatar';
import listItems from 'flarum/common/helpers/listItems';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';

app.initializers.add('tf/custom-discussions-details', () => {
  
  // 移除 PostUser 组件中的徽章
  extend(PostUser.prototype, 'userViewItems', function (items) {
    // 移除 postUser-badges 项
    if (items.has('postUser-badges')) {
      items.remove('postUser-badges');
    }
  });

  // 删除 DiscussionHero 面板
  extend(DiscussionPage.prototype, 'pageContent', function (items) {
    // 移除 hero 项
    if (items.has('hero')) {
      items.remove('hero');
    }
  });
// 在第一个 Post 的 Post-header 上方添加面包屑导航
  // 同时扩展 Post 和 CommentPost，因为首帖可能使用不同的组件渲染
  const addBreadcrumb = function (items) {
    const post = this.attrs.post;
    
    // 只在第一个帖子（number === 1）中添加面包屑
    if (post && post.number() === 1) {
      const discussion = post.discussion();
      if (discussion) {
        // 在 header 之前添加面包屑（优先级高于 header 的 100）
        items.add(
          'breadcrumb',
          <Breadcrumb discussion={discussion} />,
          110
        );
      }
    }
  };
  extend(Post.prototype, 'contentItems', addBreadcrumb);
  extend(CommentPost.prototype, 'contentItems', addBreadcrumb);
  // 在详情页 PostStream 区域顶部添加面包屑（Home > 分类 > 标题）
  extend(DiscussionPage.prototype, 'mainContent', function (items) {
    if (this.discussion && items.has('poststream')) {
      items.replace(
        'poststream',
        <div className="DiscussionPage-stream">
          <PostStreamBreadcrumb discussion={this.discussion} />
          <PostStream
            discussion={this.discussion}
            stream={this.stream}
            onPositionChange={this.positionChanged.bind(this)}
          />
        </div>
      );
    }
  });

  // 面包屑已移至 PostStream 顶部（PostStreamBreadcrumb），不再在首帖内显示
  // 原有 Breadcrumb 组件保持不变

  // 将 Post-actions 移到 Post-body 最下边，并添加 reply-avatars（左右布局）
  extend(CommentPost.prototype, 'bodyItems', function (items) {
    const post = this.attrs.post;
    const discussion = post.discussion();
    const component = this; // 保存组件实例引用
    
    // 获取点赞数和评论数
    // 优先从 data.relationships.likes.data 获取（这是我们手动更新的地方，最准确）
    let likesCount = 0;
    try {
      // 优先从 data.relationships.likes.data 获取（最准确，因为我们手动更新这里）
      if (post.data && post.data.relationships && post.data.relationships.likes) {
        const likesData = post.data.relationships.likes.data;
        if (Array.isArray(likesData)) {
          likesCount = likesData.length;
        }
      }
      // 如果上面没有，尝试从 likes() relationship 获取
      if (likesCount === 0 && post.likes && typeof post.likes === 'function') {
        const likes = post.likes();
        if (likes) {
          if (Array.isArray(likes)) {
            likesCount = likes.length;
          } else if (typeof likes.length === 'number') {
            likesCount = likes.length;
          } else if (typeof likes.toArray === 'function') {
            likesCount = likes.toArray().length;
          }
        }
      }
      // 如果以上方法都没有，尝试使用 post.likesCount() 方法
      if (likesCount === 0 && post.likesCount && typeof post.likesCount === 'function') {
        likesCount = post.likesCount() || 0;
      }
      // 最后尝试从 attributes 获取
      if (likesCount === 0 && post.data && post.data.attributes) {
        if (post.data.attributes.likesCount !== undefined) {
          likesCount = post.data.attributes.likesCount || 0;
        }
      }
    } catch (e) {
      // 忽略错误
    }
    
    // 获取本 post 被回复的次数
    // 根据实际的回复关系数据来计算：统计有多少个post回复了当前post
    let replyCount = 0;
    const currentPostId = post.id ? String(post.id()) : null;
    const currentPostNumber = post.number ? post.number() : 0;
    const postNumber = currentPostNumber; // 用于权限检查
    
    if (discussion && currentPostId) {
      try {
        // 方法1: 尝试从post的attributes中获取replyCount（如果后端提供了这个字段）
        if (post.data && post.data.attributes && post.data.attributes.replyCount !== undefined) {
          replyCount = parseInt(post.data.attributes.replyCount) || 0;
        }
        
        // 如果attributes中没有，直接使用mentionedBy关系统计
        if (replyCount === 0) {
          // 方法1: 检查relationships.mentionedBy（这是正确的！mentionedBy表示"被哪些posts提到"）
          if (post.data && post.data.relationships && post.data.relationships.mentionedBy) {
            const mentionedByData = post.data.relationships.mentionedBy.data;
            if (Array.isArray(mentionedByData)) {
              // mentionedBy.data 数组的长度就是回复数
              replyCount = mentionedByData.filter(mention => {
                if (!mention) return false;
                // 只统计type为'posts'的mention
                return mention.type === 'posts';
              }).length;
            }
          }
          
          // 方法2: 检查mentionedBy()方法（如果存在）
          if (replyCount === 0 && post.mentionedBy && typeof post.mentionedBy === 'function') {
            try {
              const mentionedBy = post.mentionedBy();
              if (mentionedBy) {
                let mentionedByArray = [];
                if (typeof mentionedBy.toArray === 'function') {
                  mentionedByArray = mentionedBy.toArray();
                } else if (Array.isArray(mentionedBy)) {
                  mentionedByArray = mentionedBy;
                }
                replyCount = mentionedByArray.length;
              }
            } catch (e) {
              // 忽略错误
            }
          }
        }
        
        // 第一个post特殊处理：显示总回复数（commentCount - 1）
        if (currentPostNumber === 1) {
          const totalCommentCount = discussion.commentCount ? discussion.commentCount() : 0;
          const totalReplies = Math.max(0, totalCommentCount - 1);
          // 使用总回复数，因为第一个post应该显示整个讨论的回复数
          replyCount = totalReplies;
        }
        // 对于其他post，使用通过mentionedBy关系统计的实际回复数
        // 如果统计为0，说明真的没有回复，就显示0（不使用fallback）
      } catch (e) {
        // 出错时使用fallback逻辑
      const totalCommentCount = discussion.commentCount ? discussion.commentCount() : 0;
        if (currentPostNumber === 1) {
          replyCount = Math.max(0, totalCommentCount - 1);
    } else {
          replyCount = (totalCommentCount > currentPostNumber) ? 1 : 0;
        }
      }
    }
    
    // 获取回复用户
    // 对于第一个post，使用整个讨论的回复用户
    // 对于子评论（第一条除外的），使用本评论的回复评论用户
    let replyUsers = [];
    const maxAvatars = 5;
    
    if (currentPostNumber === 1) {
      // 第一个post：使用整个讨论的回复用户
      replyUsers = discussion && discussion.data && discussion.data.attributes ? (discussion.data.attributes.replyUsers || []) : [];
    } else {
      // 子评论：从 mentionedBy 关系中获取回复了当前 post 的用户
      try {
        const mentionedByPosts = [];
        
        // 方法1: 从 relationships.mentionedBy 获取
        if (post.data && post.data.relationships && post.data.relationships.mentionedBy) {
          const mentionedByData = post.data.relationships.mentionedBy.data;
          if (Array.isArray(mentionedByData)) {
            // 过滤出 type 为 'posts' 的 mention
            const postMentions = mentionedByData.filter(mention => mention && mention.type === 'posts');
            // 从 store 中获取这些 posts
            postMentions.forEach(mention => {
              if (mention.id) {
                const replyPost = app.store.getById('posts', String(mention.id));
                if (replyPost) {
                  mentionedByPosts.push(replyPost);
                }
              }
            });
          }
        }
        
        // 方法2: 从 mentionedBy() 方法获取（如果存在）
        if (mentionedByPosts.length === 0 && post.mentionedBy && typeof post.mentionedBy === 'function') {
          try {
            const mentionedBy = post.mentionedBy();
            if (mentionedBy) {
              let mentionedByArray = [];
              if (typeof mentionedBy.toArray === 'function') {
                mentionedByArray = mentionedBy.toArray();
              } else if (Array.isArray(mentionedBy)) {
                mentionedByArray = mentionedBy;
              }
              mentionedByPosts.push(...mentionedByArray);
            }
          } catch (e) {
            // 忽略错误
          }
        }
        
        // 从回复的 posts 中提取用户，去重
        const userMap = new Map();
        mentionedByPosts.forEach(replyPost => {
          if (replyPost && replyPost.user && typeof replyPost.user === 'function') {
            const user = replyPost.user();
            if (user && user.id) {
              const userId = String(user.id());
              if (!userMap.has(userId)) {
                userMap.set(userId, user);
              }
            }
          }
        });
        
        // 转换为数组
        replyUsers = Array.from(userMap.values());
      } catch (e) {
        // 如果出错，使用空数组
        replyUsers = [];
      }
    }
    
    const displayUsers = replyUsers.slice(0, maxAvatars).map(userData => {
      // 如果 userData 已经是 user 对象（从 mentionedBy 获取的），直接返回
      if (userData && typeof userData.id === 'function') {
        return userData;
      }
      
      // 否则，尝试从app.store获取真实的user对象
      if (userData.id) {
        const realUser = app.store.getById('users', String(userData.id));
        if (realUser) {
          return realUser;
        }
      }
      // 如果无法获取真实user对象，创建一个兼容的对象
      return {
        id: () => userData.id,
        displayName: () => userData.displayName || userData.username,
        username: () => userData.username,
        avatarUrl: () => userData.avatarUrl,
        color: () => userData.color || null,
      };
    });
    
    // 检查当前用户是否已点赞
    // 优先从 data.relationships.likes.data 检查（最准确，因为我们手动更新这里）
    let isLiked = false;
    try {
      if (post.data && post.data.relationships && post.data.relationships.likes && app.session.user) {
        const likesData = post.data.relationships.likes.data;
        if (Array.isArray(likesData)) {
          isLiked = likesData.some(like => like.id === app.session.user.id());
        }
      }
      // 如果上面没有，尝试从 likes() relationship 获取
      if (!isLiked && post && post.likes && typeof post.likes === 'function' && app.session.user) {
        const likes = post.likes();
        if (likes) {
          if (Array.isArray(likes)) {
            isLiked = likes.some(like => like.id && like.id() === app.session.user.id());
          } else if (typeof likes.toArray === 'function') {
            isLiked = likes.toArray().some(like => like.id && like.id() === app.session.user.id());
          }
        }
      }
    } catch (e) {
      // 忽略错误
    }

    // 点赞处理函数 - 使用原生 Flarum likes 扩展的方式
    // 请求中禁止重复点击，避免连续两次取消点赞导致数量多减（如 3→1）
    const handleLikeClick = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();
      
      if (!app.session.user) return;
      if (post._likeRequestInFlight) return;

      const wasLiked = isLiked;
      const newIsLiked = !wasLiked;

      // 乐观更新：先改本地数据与 DOM，请求完成前禁止再次点击
      post._likeRequestInFlight = true;
      if (!post.data.relationships.likes) {
        post.data.relationships.likes = { data: [] };
      }
      const data = post.data.relationships.likes.data;
      const prevData = data.slice();
      const prevCount = (post.data.attributes && post.data.attributes.likesCount) !== undefined ? post.data.attributes.likesCount : data.length;

      data.some((like, i) => {
        if (like.id === app.session.user.id()) {
          data.splice(i, 1);
          return true;
        }
      });
      if (newIsLiked) {
        data.unshift({ type: 'users', id: app.session.user.id() });
      }
      const newCount = data.length;
      if (post.data.attributes) {
        post.data.attributes.likesCount = newCount;
      }

      const $post = component.$();
      if ($post.length) {
        const $likeCount = $post.find('.Post-stat-item.Post-likes .Post-stat-count');
        if ($likeCount.length) $likeCount.text(newCount || 0);
        const $likeIcon = $post.find('.Post-stat-item.Post-likes i');
        if ($likeIcon.length) $likeIcon.removeClass('fas far').addClass(newIsLiked ? 'fas' : 'far').addClass('fa-heart');
        const $likeItem = $post.find('.Post-stat-item.Post-likes');
        if ($likeItem.length) {
          if (newIsLiked) $likeItem.addClass('is-liked');
          else $likeItem.removeClass('is-liked');
        }
      }
      if (typeof m !== 'undefined' && m.redraw) m.redraw.sync();

      try {
        await post.save({ isLiked: newIsLiked });
        // 点赞后数量以接口返回为准（如 /api/posts/6307 的 likesCount），不自己计算；Flarum 已把响应合并到 post
        const isFirstPost = discussion && (post.number?.() === 1 || post === (discussion.firstPost && discussion.firstPost()));
        if (isFirstPost && discussion && discussion.data && discussion.data.attributes && post.data && post.data.attributes) {
          if (post.data.attributes.likesCount !== undefined) discussion.data.attributes.likesCount = Number(post.data.attributes.likesCount);
          if (post.data.attributes.isLiked !== undefined) discussion.data.attributes.isLiked = post.data.attributes.isLiked === true || post.data.attributes.isLiked === 1;
        }
      } catch (err) {
        // 回滚：恢复 relationship 与 attributes
        post.data.relationships.likes.data.length = 0;
        prevData.forEach((item) => post.data.relationships.likes.data.push(item));
        if (post.data.attributes) post.data.attributes.likesCount = prevCount;
        if ($post.length) {
          const $likeCount = $post.find('.Post-stat-item.Post-likes .Post-stat-count');
          if ($likeCount.length) $likeCount.text(prevCount);
          const $likeIcon = $post.find('.Post-stat-item.Post-likes i');
          if ($likeIcon.length) $likeIcon.removeClass('fas far').addClass(wasLiked ? 'fas' : 'far').addClass('fa-heart');
          const $likeItem = $post.find('.Post-stat-item.Post-likes');
          if ($likeItem.length) {
            if (wasLiked) $likeItem.addClass('is-liked');
            else $likeItem.removeClass('is-liked');
          }
        }
        if (typeof m !== 'undefined' && m.redraw) m.redraw.sync();
      } finally {
        post._likeRequestInFlight = false;
        if (typeof m !== 'undefined' && m.redraw) m.redraw.sync();
      }
    };

    // 回复处理函数
    // 参考原生实现：DiscussionControls.replyAction 和 mentions 扩展的 reply 函数
    const handleReplyClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!app.session.user) {
        // 如果未登录，显示登录提示
        app.modal.show(LogInModal);
        return;
      }

      // 从 post 获取 discussion
      const postDiscussion = post.discussion();
      if (!postDiscussion) {
        return;
      }

      // 若 canReply 为假，强制设置为 true 确保 composer 可打开
      if (!postDiscussion.canReply || !postDiscussion.canReply()) {
        if (typeof postDiscussion.pushAttributes === 'function') {
          postDiscussion.pushAttributes({ canReply: true });
        } else if (postDiscussion.data && postDiscussion.data.attributes) {
          postDiscussion.data.attributes.canReply = true;
        }
      }

      // 如果当前 post 不是第一个 post，尝试在回复内容中插入 mention
      // 否则使用原生的回复方式
      if (postNumber > 1) {
        // 其他 post：先打开回复编辑器，然后尝试插入 mention
        // 参考 mentions 扩展的实现方式
        DiscussionControls.replyAction.call(postDiscussion, true, false).then((composer) => {
          // 如果 mentions 扩展可用，尝试插入 mention
          if (app.mentionFormats && app.mentionFormats.mentionable) {
            try {
              const mention = app.mentionFormats.mentionable('post').replacement(post) + ' ';
              if (composer && composer.fields && composer.editor) {
                const cursorPosition = composer.editor.getSelectionRange()[0];
                const preceding = composer.fields.content().slice(0, cursorPosition);
                const precedingNewlines = preceding.length == 0 ? 0 : 3 - preceding.match(/(\n{0,2})$/)[0].length;
                composer.editor.insertAtCursor(
                  Array(precedingNewlines).join('\n') + mention,
                  false
                );
              }
            } catch (e) {
              // 忽略错误
            }
          }
        }).catch((error) => {
          // 忽略错误
        });
      } else {
        // 第一个 post：使用原生的回复方式
        // 参考 DiscussionControls.replyAction 的实现
        DiscussionControls.replyAction.call(postDiscussion, true, false).catch((error) => {
          // 忽略错误
        });
      }
    };

    // 检查置顶权限：使用 discussion 的置顶权限（官方方法）
    // 第一个帖子：检查 discussion 的置顶权限（用于置顶整个讨论）
    // 其他帖子：检查 discussion 的置顶权限（用于置顶单个回复）
    const canSticky = discussion && discussion.canSticky && discussion.canSticky();
    
    // 检查置顶状态
    let isSticky = false;
    if (postNumber === 1) {
      // 第一个帖子：检查 discussion 的置顶状态
      if (discussion.isSticky && typeof discussion.isSticky === 'function') {
        isSticky = discussion.isSticky();
      } else if (discussion.data && discussion.data.attributes && discussion.data.attributes.isSticky !== undefined) {
        isSticky = !!discussion.data.attributes.isSticky;
      }
    } else {
      // 其他帖子：检查 post 的置顶状态
      if (post.isSticky && typeof post.isSticky === 'function') {
        isSticky = post.isSticky();
      } else if (post.data && post.data.attributes && post.data.attributes.isSticky !== undefined) {
        isSticky = !!post.data.attributes.isSticky;
      }
    }
    
    // 检查删除权限
    // 
    // Flarum 权限机制说明：
    // 1. 第一个帖子：删除第一个帖子会删除整个讨论，检查 discussion.canDelete() 权限
    // 2. 其他帖子：删除单个评论，检查 post.canDelete() 权限
    //    - PostSerializer 通过 $actor->can('delete', $post) 检查权限
    //    - PostPolicy 的 can() 方法检查 $actor->can('deletePosts', $post->discussion)
    //    - DiscussionPolicy 检查 $actor->hasPermission('discussion.deletePosts')
    //    - 所以删除帖子的权限实际上是 discussion.deletePosts
    //
    let canDelete = false;
    // postNumber 已在上面定义（第 106 行），直接使用
    const isFirstPost = postNumber === 1;
    if (isFirstPost) {
      // 第一个帖子：检查是否有删除整个讨论的权限
      try {
        // 方式1: 使用 discussion.canDelete() 方法
        if (discussion && discussion.canDelete && typeof discussion.canDelete === 'function') {
          const result = discussion.canDelete();
          if (result !== undefined && result !== null) {
            canDelete = result === true || result === 1;
          }
        }
        
        // 方式2: 使用 attribute 方法
        if (!canDelete && discussion && discussion.attribute && typeof discussion.attribute === 'function') {
          const attrValue = discussion.attribute('canDelete');
          if (attrValue !== undefined && attrValue !== null) {
            canDelete = attrValue === true || attrValue === 1;
          }
        }
        
        // 方式3: 从 data.attributes 获取
        if (!canDelete && discussion && discussion.data && discussion.data.attributes) {
          const attrCanDelete = discussion.data.attributes.canDelete;
          if (attrCanDelete !== undefined && attrCanDelete !== null) {
            canDelete = attrCanDelete === true || attrCanDelete === 1;
          }
        }
      } catch (e) {
        console.error('Error checking discussion canDelete permission:', e);
        canDelete = false;
      }
    } else {
      // 其他帖子：检查是否有删除单个帖子的权限
      try {
        // 方式1: 直接从 data.attributes 获取（最可靠，因为这是 API 返回的原始值）
        if (post.data && post.data.attributes && post.data.attributes.canDelete !== undefined) {
          const attrCanDelete = post.data.attributes.canDelete;
          // 严格检查：只有明确为 true 或 1 时才允许删除
          canDelete = attrCanDelete === true || attrCanDelete === 1;
        }
        
        // 方式2: 使用 canDelete() 方法（Flarum Model 的标准方法）
        if (!canDelete && post.canDelete && typeof post.canDelete === 'function') {
          try {
            const result = post.canDelete();
            if (result !== undefined && result !== null) {
              canDelete = result === true || result === 1;
            }
          } catch (e) {
            // 如果方法调用失败，继续尝试其他方式
            console.warn('post.canDelete() method failed:', e);
          }
        }
        
        // 方式3: 使用 attribute 方法（备用方式）
        if (!canDelete && post.attribute && typeof post.attribute === 'function') {
          try {
            const attrValue = post.attribute('canDelete');
            if (attrValue !== undefined && attrValue !== null) {
              canDelete = attrValue === true || attrValue === 1;
            }
          } catch (e) {
            // 忽略错误
          }
        }
        
        // 只对评论类型的帖子显示删除按钮
        const contentType = post.contentType ? post.contentType() : null;
        if (canDelete && contentType && contentType !== 'comment') {
          canDelete = false;
        }
      } catch (e) {
        // 如果检查权限出错，不显示按钮
        console.error('Error checking post canDelete permission:', e);
        canDelete = false;
      }
    }
    
    // 调试信息：检查权限值（开发时使用）
    // if (process.env.NODE_ENV === 'development' || window.location.search.includes('debug=true')) {
    //   console.log('Delete permission check:', {
    //     postId: post.id ? post.id() : 'unknown',
    //     postNumber: postNumber,
    //     isFirstPost: isFirstPost,
    //     contentType: post.contentType ? post.contentType() : null,
    //     canDelete: canDelete,
    //     discussionCanDelete: discussion && discussion.canDelete ? discussion.canDelete() : 'no method',
    //     postCanDelete: post.canDelete ? post.canDelete() : 'no method',
    //     discussionId: discussion ? (discussion.id ? discussion.id() : 'unknown') : 'no discussion'
    //   });
    // }
    
    // 置顶处理函数（参考官方 DiscussionControls.stickyAction 的实现方式）
    const handleStickyClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (!canSticky) {
        return;
      }
      
      const newStickyState = !isSticky;
      
      // 显示加载状态
      const $button = component.$(`.Post-sticky`);
      
      if (postNumber === 1) {
        // 第一个帖子：置顶整个讨论
        discussion.save({ isSticky: newStickyState }).then((savedDiscussion) => {
          // 更新本地状态
          if (discussion.data && discussion.data.attributes) {
            discussion.data.attributes.isSticky = newStickyState;
          }
          
          // 如果保存的 discussion 有返回数据，更新状态
          if (savedDiscussion && savedDiscussion.data && savedDiscussion.data.attributes) {
            const actualStickyState = savedDiscussion.data.attributes.isSticky;
            if (discussion.data && discussion.data.attributes) {
              discussion.data.attributes.isSticky = actualStickyState;
            }
          }
          
          // 如果当前在讨论页面，更新流
          if (app.current && app.current.get && app.current.get('stream')) {
            app.current.get('stream').update();
          }
          
          // 触发重新渲染
          if (typeof m !== 'undefined' && m.redraw) {
            m.redraw();
          }
        }).catch((error) => {
          // 错误处理
          console.error('Failed to toggle discussion sticky state:', error);
          
          // 恢复按钮状态
          if ($button.length) {
            $button.css('opacity', '1');
          }
          
          // 显示错误提示
          if (error && error.response && error.response.errors) {
            const errorMessage = error.response.errors[0]?.detail || '操作失败';
            app.alerts.show({ type: 'error' }, app.translator.trans('core.forum.post_controls.error_message', { message: errorMessage }));
          } else {
            app.alerts.show({ type: 'error' }, app.translator.trans('core.forum.post_controls.error_message', { message: '无法更新置顶状态，请检查后端是否支持此功能' }));
          }
        });
      } else {
        // 其他帖子：置顶单个回复
        post.save({ isSticky: newStickyState }).then((savedPost) => {
          // 更新本地状态
          if (post.data && post.data.attributes) {
            post.data.attributes.isSticky = newStickyState;
          }
          
          // 如果保存的 post 有返回数据，更新状态
          if (savedPost && savedPost.data && savedPost.data.attributes) {
            const actualStickyState = savedPost.data.attributes.isSticky;
            if (post.data && post.data.attributes) {
              post.data.attributes.isSticky = actualStickyState;
            }
          }
          
          // 如果当前在讨论页面，更新流
          if (app.current && app.current.get && app.current.get('stream')) {
            app.current.get('stream').update();
          }
          
          // 触发重新渲染
          if (typeof m !== 'undefined' && m.redraw) {
            m.redraw();
          }
        }).catch((error) => {
          // 错误处理
          console.error('Failed to toggle post sticky state:', error);
          
          // 恢复按钮状态
          if ($button.length) {
            $button.css('opacity', '1');
          }
          
          // 显示错误提示
          if (error && error.response && error.response.errors) {
            const errorMessage = error.response.errors[0]?.detail || '操作失败';
            app.alerts.show({ type: 'error' }, app.translator.trans('core.forum.post_controls.error_message', { message: errorMessage }));
          } else {
            app.alerts.show({ type: 'error' }, app.translator.trans('core.forum.post_controls.error_message', { message: '无法更新置顶状态，请检查后端是否支持此功能' }));
          }
        });
      }
    };
    
    // 是否有编辑权限（与 PostControls.moderationControls 中 edit 条件一致）
    const canEdit = post.contentType && post.contentType() === 'comment'
      && post.canEdit && post.canEdit()
      && (typeof post.isHidden !== 'function' || !post.isHidden());
    
    // 编辑：直接使用系统原有 PostControls.editAction
    const handleEditClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (post && PostControls.editAction) {
        PostControls.editAction.call(post);
      }
    };
    
    // 删除处理函数
    const handleDeleteClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (!post || !discussion) return;
      
      const postNumber = post.number ? post.number() : 0;
      const isFirstPost = postNumber === 1;
      
      // 如果是第一个帖子，删除整个讨论
      if (isFirstPost) {
        // 检查是否有删除讨论的权限
        let canDeleteDiscussion = false;
        try {
          if (discussion && discussion.canDelete && typeof discussion.canDelete === 'function') {
            canDeleteDiscussion = discussion.canDelete() === true;
          } else if (discussion && discussion.data && discussion.data.attributes) {
            canDeleteDiscussion = discussion.data.attributes.canDelete === true;
          }
        } catch (e) {
          console.error('Error checking discussion canDelete:', e);
        }
        
        if (!canDeleteDiscussion) {
          app.alerts.show({ type: 'error' }, app.translator.trans('core.forum.discussion_controls.cannot_delete'));
          return;
        }
        
        // 使用 DiscussionControls.deleteAction 删除整个讨论
        // deleteAction 内部已经有确认对话框，不需要再次确认
        if (DiscussionControls.deleteAction) {
          DiscussionControls.deleteAction.call(discussion);
        } else {
          // 如果没有 deleteAction，直接调用 delete 方法（需要手动确认）
          if (confirm(app.translator.trans('core.forum.discussion_controls.delete_confirmation'))) {
            discussion.delete().then(() => {
              // 删除成功后跳转到首页
              m.route.set(app.route('index'));
            }).catch((error) => {
              console.error('Error deleting discussion:', error);
              app.alerts.show({ type: 'error' }, app.translator.trans('core.forum.discussion_controls.delete_error'));
            });
          }
        }
      } else {
        // 删除单个帖子（评论）
        // 检查是否有删除帖子的权限
        let canDeletePost = false;
        try {
          if (post.canDelete && typeof post.canDelete === 'function') {
            canDeletePost = post.canDelete() === true;
          } else if (post.data && post.data.attributes) {
            canDeletePost = post.data.attributes.canDelete === true;
          }
        } catch (e) {
          console.error('Error checking post canDelete:', e);
        }
        
        if (!canDeletePost) {
          app.alerts.show({ type: 'error' }, app.translator.trans('core.forum.post_controls.cannot_delete'));
          return;
        }
        
        // 使用 PostControls.deleteAction 删除单个帖子
        // deleteAction 内部已经有确认对话框，不需要再次确认
        if (PostControls.deleteAction) {
          PostControls.deleteAction.call(post, component);
        } else {
          // 如果没有 deleteAction，直接调用 delete 方法（需要手动确认）
          if (confirm(app.translator.trans('core.forum.post_controls.delete_confirmation'))) {
            post.delete().then(() => {
              // 删除成功后刷新页面
              m.redraw();
            }).catch((error) => {
              console.error('Error deleting post:', error);
              app.alerts.show({ type: 'error' }, app.translator.trans('core.forum.post_controls.delete_error'));
            });
          }
        }
      }
    };

    // 创建左右布局的容器
    items.add(
      'postStats',
      <div className="Post-stats">
        <div className="Post-stats-left">
          <span 
            className={`Post-stat-item Post-likes ${isLiked ? 'is-liked' : ''} ${post._likeRequestInFlight ? 'is-loading' : ''}`}
            role="button"
            tabIndex={post._likeRequestInFlight ? -1 : 0}
            onclick={handleLikeClick}
            ontouchend={handleLikeClick}
            style={{ cursor: post._likeRequestInFlight ? 'wait' : 'pointer', touchAction: 'manipulation', pointerEvents: post._likeRequestInFlight ? 'none' : undefined }}
          >
            <i className={isLiked ? 'fa-solid fa-heart' : 'fa-light fa-heart'}></i>
            <span className="Post-stat-count">{likesCount || 0}</span>
          </span>
          <span 
            className="Post-stat-item Post-comments"
            onclick={handleReplyClick}
            style="cursor: pointer;"
          >
            <i className="fa-light fa-comment"></i>
            <span className="Post-stat-count">{replyCount || 0}</span>
          </span>
          {canSticky && (
            <span 
              className={`Post-stat-item sticky-button ${isSticky ? 'is-sticky' : ''}`}
              onclick={handleStickyClick}
              title={app.translator.trans(isSticky ? 'flarum-sticky.forum.discussion_controls.unsticky_button' : 'flarum-sticky.forum.discussion_controls.sticky_button')}
            >
              <i className={`fa-light fa-thumbtack ${isSticky ? '' : 'fa-rotate-90'}`}></i>
              <span className="sticky-text">
                {isSticky ? app.translator.trans('flarum-sticky.forum.discussion_controls.unsticky_button') : app.translator.trans('flarum-sticky.forum.discussion_controls.sticky_button')}
              </span>
            </span>
          )}
          {canEdit && (
            <span 
              className="Post-stat-item item-edit"
              onclick={handleEditClick}
              style="cursor: pointer;"
              title={app.translator.trans('core.forum.post_controls.edit_button')}
            >
              <i className="fa-light fa-pencil-alt"></i>
              {app.translator.trans('core.forum.post_controls.edit_button')}
            </span>
          )}
          {canDelete && (
            <span 
              className="Post-stat-item Post-delete"
              onclick={handleDeleteClick}
              style="cursor: pointer;"
              title={isFirstPost 
                ? app.translator.trans('core.forum.discussion_controls.delete_forever_button') 
                : app.translator.trans('core.forum.post_controls.delete_forever_button')}
            >
              <i className="fa-light fa-trash-alt"></i>
              {isFirstPost 
                ? app.translator.trans('core.forum.discussion_controls.delete_button') 
                : app.translator.trans('core.forum.post_controls.delete_button')}
            </span>
          )}
        </div>
        {displayUsers.length > 0 && (
          <div className="Post-stats-right Post-reply-avatars">
            <div className="avatars-list">
              {displayUsers.map((user, index) => {
                if (!user) return null;
                
                const displayName = user.displayName ? user.displayName() : (user.username ? user.username() : '');
                const username = user.username ? user.username() : '';
                const avatarUrl = user.avatarUrl ? user.avatarUrl() : null;
                
                if (avatarUrl || username) {
                  return (
                    <span 
                      key={index} 
                      className="Post-reply-avatar" 
                      title={displayName || username}
                    >
                      {avatar(user, { size: 20 })}
                    </span>
                  );
                }
                return null;
              })}
              {replyUsers.length > maxAvatars && (
                <span className="more-avatars" title={`还有 ${replyUsers.length - maxAvatars} 个回复`}>
                  +{replyUsers.length - maxAvatars}
                </span>
              )}
            </div>
          </div>
        )}
      </div>,
      3 // 在 actions 之前
    );
    
    // 添加 actions 到底部（优先级最低）
    // 使用不同的名称 'postActions' 避免与 viewItems 中的 'actions' 冲突
    // 从 dropdown 中排除 edit，因已移到 Post-stats-left 的 Post-delete 前
    const controls = PostControls.controls(post, this).toArray();
    const controlsWithoutEdit = controls.filter((c) => !c || c.itemName !== 'edit');
    const actionItems = this.actionItems().toArray();
    
    items.add(
      'postActions',
      <aside className="Post-actions Post-actions-new">
        <ul>
          {listItems(actionItems)}
          {!!controlsWithoutEdit.length && (
            <li>
              <Dropdown
                className="Post-controls"
                buttonClassName="Button Button--icon Button--flat"
                menuClassName="Dropdown-menu--right"
                icon="fa-light fa-ellipsis-h"
                onshow={() => this.$('.Post-controls').addClass('open')}
                onhide={() => this.$('.Post-controls').removeClass('open')}
                accessibleToggleLabel={app.translator.trans('core.forum.post_controls.toggle_dropdown_accessible_label')}
              >
                {controlsWithoutEdit}
              </Dropdown>
            </li>
          )}
        </ul>
      </aside>,
      1 // 最低优先级，放在最底部
    );
  });

  // 在 DiscussionPage 的侧边栏中添加 Related Topics
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    const discussion = this.discussion;
    if (discussion) {
      items.add(
        'relatedTopics',
        <RelatedTopics discussion={discussion} />,
        -200 // 最低优先级，放在最底部（scrubber 是 -100）
      );
    }
  });

  // ============================================
  // 优化 subscriptions 扩展的图标显示
  // ============================================

  // 修改 DiscussionControls 中的关注按钮图标
  extend(DiscussionControls, 'userControls', function (items, discussion, context) {
    if (app.session.user && !(context instanceof DiscussionPage)) {
      const subscription = discussion.subscription() || 'none';
      
      // 如果已经有 subscription 项，修改它的图标
      if (items.has('subscription')) {
        const subscriptionItem = items.get('subscription');
        if (subscriptionItem && subscriptionItem.attrs) {
          // 根据订阅状态修改图标：未关注使用 fa-light，已关注使用 fa-solid
          if (subscription === 'follow') {
            subscriptionItem.attrs.icon = 'fa-solid fa-star';
          } else {
            subscriptionItem.attrs.icon = 'fa-light fa-star';
          }
        }
      }
    }
  });

  // ============================================
  // fof/upload 下载按钮：未登录时弹出登录框而非提示无法下载
  // 使用较高优先级确保在 fof/upload 绑定之后执行，覆盖其点击逻辑
  // ============================================
  extend(Post.prototype, 'oncreate', function () {
    const $downloadBtns = this.$('[data-fof-upload-download-uuid]');
    if (!$downloadBtns.length) return;

    $downloadBtns.unbind('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (!app.forum.attribute('fof-upload.canDownload')) {
        // 未登录：弹出登录框，引导用户登录
        if (!app.session.user) {
          app.modal.show(LogInModal);
        } else {
          // 已登录但无权限：显示原提示
          alert(app.translator.trans('fof-upload.forum.states.unauthorized'));
        }
        return;
      }

      const url = app.forum.attribute('apiUrl') + '/fof/download'
        + '/' + encodeURIComponent(e.currentTarget.dataset.fofUploadDownloadUuid)
        + '/' + encodeURIComponent(this.attrs.post.id())
        + '/' + encodeURIComponent(app.session.csrfToken);
      window.open(url);
    });
  }, 10);
});

// 在 subscriptions 扩展加载后优化图标显示
// 使用较低的优先级确保在 subscriptions 扩展之后执行
app.initializers.add('tf/custom-discussions-details-subscriptions', () => {
  const { extend } = require('flarum/common/extend');
  
  // 延迟执行以确保 subscriptions 扩展已完全加载
  setTimeout(() => {
    try {
      // 检查 subscriptions 扩展是否已加载
      if (typeof flarum === 'undefined' || 
          !flarum.core || 
          !flarum.core.compat || 
          !flarum.core.compat['subscriptions/js/src/forum/components/SubscriptionMenu']) {
        // subscriptions 扩展未安装或未加载，跳过扩展
        return;
      }
      
      // 动态导入 SubscriptionMenu 组件（使用兼容模式）
      let SubscriptionMenu = null;
      try {
        const SubscriptionMenuModule = flarum.core.compat['subscriptions/js/src/forum/components/SubscriptionMenu'];
        SubscriptionMenu = SubscriptionMenuModule.default || SubscriptionMenuModule;
      } catch (importError) {
        // 如果导入失败，使用 CSS fallback（已在 custom-fonts.css 中处理）
        return;
      }
      
      if (!SubscriptionMenu) {
        // SubscriptionMenu 未找到，使用 CSS fallback（已在 custom-fonts.css 中处理）
        return;
      }
      
      // 修改 oninit 方法中的图标选项
      extend(SubscriptionMenu.prototype, 'oninit', function (vnode) {
        // 在原始 oninit 执行后修改图标
        if (this.options && Array.isArray(this.options)) {
          this.options.forEach(option => {
            if (option.icon) {
              if (option.subscription === 'follow') {
                option.icon = 'fa-solid fa-star';
              } else if (option.subscription === null) {
                option.icon = 'fa-light fa-star';
              } else if (option.subscription === 'ignore') {
                option.icon = 'fa-light fa-eye-slash';
              }
            }
          });
        }
      });

      // 修改 view 方法中的按钮图标
      extend(SubscriptionMenu.prototype, 'view', function () {
        const discussion = this.attrs.discussion;
        const subscription = discussion.subscription();
        
        // 调用原始 view 方法
        const vnode = this.constructor.prototype.view.call(this);
        
        // 修改按钮图标
        if (vnode && vnode.children && Array.isArray(vnode.children)) {
          vnode.children.forEach(child => {
            if (child && child.attrs && child.attrs.icon) {
              // 根据订阅状态修改图标
              if (subscription === 'follow') {
                child.attrs.icon = 'fa-solid fa-star';
              } else {
                child.attrs.icon = 'fa-light fa-star';
              }
            }
          });
        }
        
        return vnode;
      });
    } catch (e) {
      // 如果无法导入，使用 CSS 方式处理（已在 custom-fonts.css 中处理）
      // 静默处理错误，不输出到控制台，避免错误信息干扰
    }
  }, 300);
}, -10); // 使用负优先级确保在 subscriptions 扩展之后执行

